import { makeStyles, Theme, createStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    paper: {
      padding: '0 0 0 4px',
      margin: '32px 0',
      display: 'flex',
      alignItems: 'center',
      width: '100%',
    },
    body: {
      padding: '0 0px 16px 0px',
      backgroundColor: '#F5F5F5',
    },
    input: {
      marginLeft: theme.spacing(1),
      flex: 1,
    },
    iconButton: {
      padding: 10,
    },
    searchButton: {
      padding: 12,
      borderTopLeftRadius: 0,
      borderBottomLeftRadius: 0,
    },
    resultContainer: {
      padding: '1rem 0',
    },
    noResults: {
      padding: '2rem 0',
    },
  })
);
